import { FC } from 'react';

import { Share } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useTranslate } from 'hooks/useTranslate';
import PartnerSharesTableRow from './PartnerSharesTableRow';
import { usePartnerShares } from '../context/PartnerSharesContext';

const PartnerSharesTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = usePartnerShares();

  const firstItemIndex = (data.page - 1) * data.rowsPerPage + 1;

  const hasData = data.shares && data.shares.length > 0;

  const noDataMessage = data.isCoOwner
    ? t('ThisPartnerHasNoEncumbrances')
    : t('ThisPartnerHasNoShares');

  const rows = data.shares?.map((share: Share, index: number) => (
    <PartnerSharesTableRow
      key={share._id ?? `share-row-${index}`}
      index={index + firstItemIndex}
      share={share}
    />
  ));

  return (
    <TableBody hasData={hasData} content={rows} noDataMessage={noDataMessage} />
  );
};

export default PartnerSharesTableBody;
